import { useMemo } from 'react';
import { isNil } from 'lodash-es';
import { getPromoteConfig } from 'services/api/pay';
import { useAuthorization } from 'components/Authorization';
import { tolgee } from 'services/i18n/tolgee';
import languageOptions from 'components/SystemLangs/languageOptions';
import { useQuery } from '@tanstack/react-query';

/**
 *
 * @param startTs 活动时间戳
 * @param endTs 活动结束时间戳
 * @returns <any>
 */
const clacInRange = (startTs: number, endTs: number) => {
  const now = new Date();
  const nowTs = now.valueOf();
  const isAfterStart = nowTs >= startTs;
  const isBeforeEnd = nowTs < endTs;
  const inPromoteRange = isAfterStart && isBeforeEnd;
  const diffSecs = (endTs - nowTs) / 1000;
  let diffDays = 0;
  if (inPromoteRange) {
    // eslint-disable-next-line no-bitwise
    const diffHours = (diffSecs / 3600) >> 0;
    // eslint-disable-next-line no-bitwise
    diffDays = ((diffHours / 24) >> 0) + 1;
  }
  return { promoteLeftDays: diffDays, inPromoteRange };
};

export const PROMOTE_I18N_NS = 'promote';

const usePromoteDays = () => {
  const auth = useAuthorization<Oversea.Token.Payload>();
  // #region 推广活动相关
  const { data = null } = useQuery({
    queryKey: ['promteConfig'],
    enabled: !!auth.payload?.orgId,
    queryFn: () => {
      return getPromoteConfig(auth.payload?.orgId!).then((r) => {
        const rsp = r.data.data;
        if (rsp?.multiLanguage?.language) {
          const staticData: Record<string, any> = {};
          languageOptions.forEach(({ value }) => {
            let lng: string = value;
            if (value === 'en-US') {
              lng = 'en';
            } else if (value === 'zh-CN') {
              lng = 'cn';
            } else if (value === 'vi') {
              lng = 'vn';
            }
            const resource =
              // @ts-ignore
              rsp.multiLanguage.language[lng] ||
              rsp.multiLanguage.language.en ||
              rsp.multiLanguage.language.cn;
            staticData[`${value}:${PROMOTE_I18N_NS}`] = resource;
          });
          tolgee.addStaticData(staticData);
        }
        return rsp;
      });
    },
  });
  const config = data;
  const shouldSkip = !!config?.isNoPopup;
  return useMemo(() => {
    if (!config) {
      return { promoteLeftDays: 0, inPromoteRange: false, skipModal: true };
    }
    const { startTime, endTime } = config;
    const startTs = parseInt(`${startTime}`, 10);
    const endTs = parseInt(`${endTime}`, 10);
    const { promoteLeftDays, inPromoteRange } = clacInRange(startTs, endTs);
    const skipModal = isNil(shouldSkip) ? true : shouldSkip;
    return { promoteLeftDays, inPromoteRange, skipModal, config };
  }, [config, shouldSkip]);
  // #endregion 推广活动相关
};

export default usePromoteDays;
